import { Flex } from '@chakra-ui/react'

import chakraTokenToVar from '@/utils/chakraTokenToVar'

import type { Query } from '@/client/query'

import SessionBoxFromQuery from './SessionBoxFromQuery'

const SessionBoxWithOutline: React.FC<{
  session: Query
  hideEntrypoint?: boolean
}> = ({ session, hideEntrypoint = false }) => (
  <Flex
    flex={1}
    direction="column"
    height="100%"
    bgColor="bg"
    borderRadius="8px"
    border={`2px solid ${chakraTokenToVar('border.emphasized')}`}
    mb="2px"
    _hover={
      hideEntrypoint
        ? {}
        : {
            cursor: 'pointer',
            bgColor: 'bg.subtle',
            border: `2px solid ${chakraTokenToVar('primary.border')}`,
          }
    }
    _active={
      hideEntrypoint
        ? {}
        : {
            bgColor: 'bg.muted',
            border: `2px solid ${chakraTokenToVar('gray.focusRing')}`,
          }
    }
  >
    <SessionBoxFromQuery hideEntrypoint={hideEntrypoint} session={session} />
  </Flex>
)

export default SessionBoxWithOutline
